import React, { useEffect, useState } from "react"
import { injectIntl } from "react-intl"
import EcommerceConfigurationRuleKeySelect from "./EcommerceRuleKeySelect"
import EcommerceConfigurationRuleTypeSelect from "./EcommerceRuleTypeSelect"
import EcommerceConfigurationRuleValuesSelect from "./EcommerceRuleValuesSelect"
import Toggle from "react-toggle"
import Icon from "../../../common/icon/icon.component.jsx"
import { EcommerceRule } from "../../../state/ecommerce-configuration/EcommerceRule"
import { Intl } from "../../../state/helpers/IntlProps"

type Props = {
    intl: Intl,
    rule: EcommerceRule,
    onUpdate: (updatedRule: EcommerceRule) => void
}


const EcommerceRuleComponent = (props: Props) => {

    const [ruleKey, setRuleKey] = useState<string>(props.rule.ruleKey)
    const [ruleType, setRuleType] = useState<string>(props.rule.ruleType)
    const [enabled, setEnabled] = useState<boolean>(props.rule.enabled)
    const [values, setValues] = useState<string[]>(props.rule.values)
    const [deleted, setDeleted] = useState<boolean>(false)

    useEffect(() => {
        props.onUpdate({
            ruleKey: ruleKey,
            ruleType: ruleType,
            enabled: enabled,
            values: values,
            deleted: deleted,
        })
    }, [ruleKey, ruleType, enabled, values, deleted])

    return (
        <div className="d-flex flex-column col-md-6 col-sm-12 mb-4">
            <div>
                <div>
                    <EcommerceConfigurationRuleKeySelect
                        selectedRuleKey={ruleKey}
                        disabled={!enabled}
                        onUpdate={(selectedRuleKey: string) => {
                            setRuleKey(selectedRuleKey)
                        }} />
                </div>
                <div className="mt-2">
                    <EcommerceConfigurationRuleTypeSelect
                        selectedRuleType={ruleType}
                        ruleKey={ruleKey}
                        disabled={!enabled}
                        onUpdate={(selectedRuleType: string) => {
                            setRuleType(selectedRuleType)
                        }} />
                </div>
                <div className="mt-2 mb-2">
                    <EcommerceConfigurationRuleValuesSelect
                        values={values}
                        ruleKey={ruleKey}
                        disabled={!enabled}
                        onUpdate={(values: string[]) => {
                            setValues(values)
                        }} />
                </div>
            </div>
            <div className="d-flex justify-content-center align-items-center">
                <div className="mr-4">
                    <Toggle
                        defaultChecked={enabled}
                        icons={false}
                        onChange={() => {
                            setEnabled(!enabled)
                        }}
                    />
                </div>
                <button
                    className="btn btn-danger ml-4"
                    onClick={(e) => {
                        e.preventDefault()
                        setDeleted(true)
                    }}
                >
                    <Icon value={"trash"} className={"mr-1"} />
                </button>
            </div>
        </div>
    )
}

export default injectIntl(EcommerceRuleComponent)



// WEBPACK FOOTER //
// ./src/settings/ecommerce/components/EcommerceRuleComponent.tsx